import { render, staticRenderFns } from "./UserSwitch.vue?vue&type=template&id=077490ea&scoped=true&"
import script from "./UserSwitch.vue?vue&type=script&lang=js&"
export * from "./UserSwitch.vue?vue&type=script&lang=js&"
import style0 from "./UserSwitch.vue?vue&type=style&index=0&id=077490ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077490ea",
  null
  
)

export default component.exports